var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.579 3.28071H1.8772V0.192993H26.579V3.28071ZM25.807 17.1754H23.4912V24.8947L29.0646 28.2295L30.2225 26.346L25.807 23.7369V17.1754ZM35.8421 23.3509C35.8421 29.3256 31.0098 34.1579 25.0351 34.1579C19.5853 34.1579 15.1081 30.1284 14.3516 24.8947H1.8772V15.6316H0.333344V12.5439L1.8772 4.82457H26.579L28.1228 12.5439V12.9916C32.5846 14.3347 35.8421 18.4569 35.8421 23.3509ZM3.48282 12.5439H24.9733L24.047 7.91229H4.40913L3.48282 12.5439ZM4.96492 21.807H14.2281V15.6316H4.96492V21.807ZM32.7544 23.3509C32.7544 19.0898 29.2962 15.6316 25.0351 15.6316C20.774 15.6316 17.3158 19.0898 17.3158 23.3509C17.3158 27.6119 20.774 31.0702 25.0351 31.0702C29.2962 31.0702 32.7544 27.6119 32.7544 23.3509Z",
    fill: "#62B5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupIcon);
export default __webpack_public_path__ + "static/media/pickup-icon.25d0cb1d3c9f202276b94f6211c21fe4.svg";
export { ForwardRef as ReactComponent };